/*
 * ConfigProjectList.tsx
 * This Config Project list Component is used to display the list of project categories and status.
 */
import { useContext, useEffect, useState } from "react";
import { eCONFIGMAPPINGS, ePrivileges } from "../../../utils/enum";
import ConfigTaskList from "./project-cat-and-work-cat/list";
import { UserContext } from "../../../context";
import Utils from "../../../utils";
import styles from "../configurations/project.module.css";
import ConfigStatusList from "./project-cat-and-status/list";
import ProjectCategoryAndWorkCategoryMapping from "./project-cat-and-work-cat/list";

function ConfigMappingsWrapper() {
  const context: any = useContext(UserContext);
  const [activeProject, setActiveProject] = useState<string>(
    eCONFIGMAPPINGS.PROJECTCATEGORYANDWORKCATEGORY
  );

  return (
    <div>
      <div className={styles.parentContainer}>
        {/* Check if user has permission to view already downloaded report list */}
        {Utils.isUserHasAccess(
          context.user?.privilegeList,
          ePrivileges.VIEWTASKCONFIGURATION
        ) && (
          <div
            className={`${styles.tab} ${
              activeProject === eCONFIGMAPPINGS.PROJECTCATEGORYANDWORKCATEGORY
                ? styles.activeTab
                : ""
            }`}
            onClick={() => {
              setActiveProject(eCONFIGMAPPINGS.PROJECTCATEGORYANDWORKCATEGORY);
            }}
          >
            <span
              className={
                activeProject === eCONFIGMAPPINGS.PROJECTCATEGORYANDWORKCATEGORY
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              Project Category & Work Category
            </span>
          </div>
        )}

        {Utils.isUserHasAccess(
          context.user?.privilegeList,
          ePrivileges.VIEWSTATUSCONFIGURATION
        ) && (
          <div
            className={`${styles.tab} ${
              activeProject === eCONFIGMAPPINGS.PROJECTCATEGORYANDSTATUS
                ? styles.activeTab
                : ""
            }`}
            onClick={() => {
              setActiveProject(eCONFIGMAPPINGS.PROJECTCATEGORYANDSTATUS);
            }}
          >
            <span
              className={
                activeProject === eCONFIGMAPPINGS.PROJECTCATEGORYANDSTATUS
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              Project Category & Status
            </span>
          </div>
        )}
      </div>
      <div>
        {activeProject === eCONFIGMAPPINGS.PROJECTCATEGORYANDWORKCATEGORY ? (
          <ProjectCategoryAndWorkCategoryMapping />
        ) : activeProject === eCONFIGMAPPINGS.PROJECTCATEGORYANDSTATUS ? (
          <ConfigStatusList />
        ) : null}
      </div>
    </div>
  );
}

export default ConfigMappingsWrapper;
